import script from "./CheckView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckView.vue?vue&type=script&lang=ts&setup=true"

import "./CheckView.vue?vue&type=style&index=0&id=7c40b318&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c40b318"]])

export default __exports__